__turbopack_context__.v({
  "canadianBadge": "ImageGallery-module-scss-module__cFpCgW__canadianBadge",
  "expandButtonWrapper": "ImageGallery-module-scss-module__cFpCgW__expandButtonWrapper",
  "galleryGrid": "ImageGallery-module-scss-module__cFpCgW__galleryGrid",
  "galleryRoot": "ImageGallery-module-scss-module__cFpCgW__galleryRoot",
  "mobileScrollbar": "ImageGallery-module-scss-module__cFpCgW__mobileScrollbar",
  "mobileScrollbarThumb": "ImageGallery-module-scss-module__cFpCgW__mobileScrollbarThumb",
});
